const requiredText = "Required";
const yesValue = "Yes";
const validateRequired = value => !value && requiredText;

const validateRequiredForSpouse = (values, errors) => {
  if (values.SpouseName) {
    if (!values.MarriageDate) {
      errors.MarriageDate = requiredText;
    }
    if (!values.SpouseJobTitle) {
      errors.SpouseJobTitle = requiredText;
    }
    if (!values.SpouseHeight) {
      errors.SpouseHeight = requiredText;
    }
    if (!values.SpouseWeight) {
      errors.SpouseWeight = requiredText;
    }
  }
};

const validateRequiredForOtherGroupPolicy = (values, errors) => {
  if (values.EmpOtherGroupPolicy === "Yes") {
    if (!values.OtherGroupPolicyName) {
      errors.OtherGroupPolicyName = requiredText;
    }
    if (!values.OtherGroupPolicyNumber) {
      errors.OtherGroupPolicyNumber = requiredText;
    }
    if (!values.OtherGroupPolicySpouseName) {
      errors.OtherGroupPolicySpouseName = requiredText;
    }
    if (!values.OtherGroupPolicySpouseIdentification) {
      errors.OtherGroupPolicySpouseIdentification = requiredText;
    }
  }
};

const validateFemaleEmpQuestions = (values, errors, membersWithUW) => {
  if (values.Gender === "Female" && membersWithUW.includes("Emp")) {
    if (!values.EmpPapSmear) {
      errors.EmpPapSmear = requiredText;
    }

    if (!values.EmpPapSmearDisorder) {
      errors.EmpPapSmearDisorder = requiredText;
    }

    if (!values.EmpMenstruationDisorder) {
      errors.EmpMenstruationDisorder = requiredText;
    }

    if (!values.EmpGynaecological) {
      errors.EmpGynaecological = requiredText;
    }

    if (!values.EmpBreastCancer) {
      errors.EmpBreastCancer = requiredText;
    }

    if (!values.EmpPregnant) {
      errors.EmpPregnant = requiredText;
    }

    if (!values.EmpHaveBeenPregnant) {
      errors.EmpHaveBeenPregnant = requiredText;
    }
  }

  if (values.SpouseGender === "Female" && membersWithUW.includes("Sp")) {
    if (!values.SpPapSmear) {
      errors.SpPapSmear = requiredText;
    }

    if (!values.SpPapSmearDisorder) {
      errors.SpPapSmearDisorder = requiredText;
    }

    if (!values.SpMenstruationDisorder) {
      errors.SpMenstruationDisorder = requiredText;
    }

    if (!values.SpGynaecological) {
      errors.SpGynaecological = requiredText;
    }

    if (!values.SpBreastCancer) {
      errors.SpBreastCancer = requiredText;
    }

    if (!values.SpPregnant) {
      errors.SpPregnant = requiredText;
    }

    if (!values.SpHaveBeenPregnant) {
      errors.SpHaveBeenPregnant = requiredText;
    }
  }
};

const validateForm = (values, props) => {
  const errors = {};
  // Set membersWithUW default value to employee to handle AIA forms without dependants' validation
  const { membersWithUW = ["Emp"] } = props;

  validateRequiredForSpouse(values, errors);
  validateRequiredForOtherGroupPolicy(values, errors);
  validateFemaleEmpQuestions(values, errors, membersWithUW);

  membersWithUW.forEach(member => {
    if (values[member + "ConsumeAlcohol"] === yesValue && !values.EmpAlcoholDetails) {
      errors.EmpAlcoholDetails = requiredText;
    }
    if (values[member + "Smoke"] === yesValue && !values.EmpSmokeQuantity) {
      errors.EmpSmokeQuantity = requiredText;
    }
    if (values[member + "SmokeLess"] === yesValue && !values.EmpSmokeLessQuantity) {
      errors.EmpSmokeLessQuantity = requiredText;
    }
    if (values[member + "WeightLoss"] === yesValue && !values.EmpWeightLossReason) {
      errors.EmpWeightLossReason = requiredText;
    }
    if (
      values[member + "PreHealthScreening"] === yesValue &&
      !values.EmpPreHealthScreeningDetails
    ) {
      errors.EmpPreHealthScreeningDetails = requiredText;
    }

    if (values[member + "PapSmear"] === yesValue && !values.EmpPapSmearResult) {
      errors.EmpPapSmearResult = requiredText;
    }

    if (values[member + "BreastCancer"] === yesValue) {
      if (!values.EmpBreastCancerFamilyRelation1) {
        errors.EmpBreastCancerFamilyRelation1 = requiredText;
      }
      if (!values.EmpBreastCancerFamilyAgeDiagnosed1) {
        errors.EmpBreastCancerFamilyAgeDiagnosed1 = requiredText;
      }
    }

    if (values[member + "Pregnant"] === yesValue && !values.EmpPregnantDurationValue) {
      errors.EmpPregnantDurationValue = requiredText;
    }
    if (values[member + "HaveBeenPregnant"] === yesValue && !values.EmpHaveBeenPregnantAge) {
      errors.EmpHaveBeenPregnantAge = requiredText;
    }
  });

  return errors;
};

export { validateForm, validateRequired };



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Aia/validation.js